import React from 'react';

const InsuranceNone = () => (
  <svg
    width="22"
    height="24"
    viewBox="0 0 59 62"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M32.53.918c-2.522 0-4.452.75-6.32 1.48-1.803.7-3.51 1.367-5.792 1.367-1.778 0-2.814-.573-4.125-1.295-1.48-.817-3.16-1.74-5.885-1.74-.743 0-1.547.07-2.384.21C2.79 1.82.137 5.646.137 12.317c0 4.283.95 7.077 1.954 10.037.678 1.997 1.38 4.062 1.933 6.886.103.53.222 1.17.354 1.89 2.048 11.136 3.72 16.79 7.164 16.79 3.67 0 4.45-4.846 5.274-9.974.635-3.956 1.506-9.372 3.604-9.372 1.685 0 3.025 6.326 3.747 9.723 1.14 5.376 2.04 9.623 5.128 9.623 5.204 0 6.35-9.31 7.184-16.108.125-1.023.234-1.93.344-2.635.454-2.894 1.007-4.97 1.54-6.98.805-3.038 1.503-5.667 1.503-9.9 0-3.113 0-11.38-7.333-11.38zm2.553 20.413c-.53 1.994-1.13 4.255-1.608 7.323-.117.735-.232 1.68-.365 2.745-1.022 8.332-2.24 12.735-3.625 13.11-.72-.868-1.49-4.483-2.006-6.913-1.292-6.102-2.63-12.41-7.06-12.41-4.99 0-6.03 6.494-6.953 12.22-.363 2.256-1.026 6.377-1.833 7.063-1.086-1.007-2.405-5.694-3.923-13.95-.134-.735-.255-1.39-.36-1.93-.597-3.047-1.368-5.318-2.048-7.324-.992-2.92-1.775-5.224-1.775-8.948 0-6.366 2.703-7.637 5.06-8.03.652-.11 1.265-.166 1.82-.166 1.855 0 2.966.612 4.25 1.32 1.28.706 2.754 1.457 4.878 1.64-3.015 1.615-6.192 3.694-6.377 3.816-.39.258-.498.785-.242 1.175.163.25.434.382.708.382.16 0 .322-.043.466-.14.06-.04 6.224-4.077 9.37-5.206.203-.07.352-.216.448-.388 1.305-.314 2.47-.748 3.536-1.162 1.717-.668 3.204-1.247 5.088-1.247 1.907 0 3.943.614 3.943 7.986-.002 3.79-.614 6.105-1.392 9.035z"
        fill="#D0CDD0"
      />
    </g>
    <circle
      fill="#FFA334"
      stroke="#FFF"
      id="a"
      cx="41.624"
      cy="44.825"
      r="13.986"
    />
    <path
      d="M33.624 44.825h16.03"
      stroke="#FFF"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default InsuranceNone;
